import LinearGradientBox from "@app/analytics/components/LinearGradientBox";
import { MarkerDot } from "@app/analytics/components/Marker";
import { AllParticipantsBox } from "@app/analytics/MeetingReport/components/StandingsCard";
import useAuth from "@app/common/auth/useAuth";

import Stack, { Row } from "@rui/Stack";

import StandingsModule from "./StandingsModule";
import { StandingsKeyText } from "./styles";
import { DeepDiveSectionHeader, DeepDiveSectionHeading } from "../styles";

const StandingsKey = () => {
  const { user } = useAuth();

  return (
    <Row spacing={2}>
      {user && (
        <Row variant="center" spacing={0.5}>
          <MarkerDot />
          <StandingsKeyText>You</StandingsKeyText>
        </Row>
      )}
      <Row variant="center" spacing={0.5}>
        <AllParticipantsBox />
        <StandingsKeyText>All Participants</StandingsKeyText>
      </Row>
      <Row variant="center" spacing={0.5}>
        <LinearGradientBox sx={{ height: "13px", width: "13px" }} />
        <StandingsKeyText>Read Average</StandingsKeyText>
      </Row>
    </Row>
  );
};

const DeepDiveStandings = () => (
  <Stack sx={{ pb: 2 }}>
    <DeepDiveSectionHeader>
      <DeepDiveSectionHeading>Standings</DeepDiveSectionHeading>
      <StandingsKey />
    </DeepDiveSectionHeader>
    <StandingsModule />
  </Stack>
);

export default DeepDiveStandings;
